import React, { Component } from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import Paper from '@material-ui/core/Paper';

const styles = theme => ({
  tablePaper: {
    padding: theme.spacing(1),
    textAlign: 'left',
    margin: theme.spacing(1),
    maxWidth: '90%',
    width: '100%',
  },
  row: {
    maxHeight: theme.spacing(4),
  },
});

class MobileTable extends Component {
  
  render() {
    const { data, columns, classes } = this.props;
    
    return (
      <>
        {data.map((object, index) =>
          <Paper key={index} className={classes.tablePaper}>
            {columns.map((column, index) =>
              column && column.value &&
              <div className={classes.row} key={index}>
                <b>{column.header}:</b> {typeof column.value === 'function' ? column.value(object) : column.value}
              </div>,
            )}
          </Paper>)}
      </>
    );
  }
  
}

export default withStyles(styles)(MobileTable);
